import React, { useEffect, useRef } from 'react';
import { ContentTrackerProps } from './types';
import { TrackEvent } from '../../../enums/Content/TrackEvent';
import MediaTracker from '../../../Services/Analytics/MediaTracker';
import VideoPlayer, { VideoPlayerProps } from '../../VideoPlayer';

export interface VideoTrackerProps
  extends VideoPlayerProps,
    ContentTrackerProps {}

const VideoTracker: React.FC<VideoTrackerProps> = (
  props: VideoTrackerProps
): JSX.Element => {
  const { contactId, contentId, roomId, track, version, ...videoPlayerProps } =
    props;

  /**
   * We only track playback time for videos
   * - We don't do viewport detection
   * - We don't turn off the tracker if another content is in fullscreen
   * - We don't turn off the tracker if the window loses focus
   *
   * Let MediaTracker be in charge of calling tracker.setActive based
   * on player interactions (play, pause, seek and other events)
   */
  const { current: tracker } = useRef(
    new MediaTracker(
      TrackEvent.VIDEO_PLAYED_SECONDS,
      contentId,
      contactId,
      roomId,
      version
    )
  );

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!track) {
      return;
    }

    tracker.attach(videoRef.current);
    return () => tracker.detach();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoRef]);

  return <VideoPlayer ref={videoRef} {...videoPlayerProps} />;
};

export default VideoTracker;
